module.exports = __webpack_public_path__ + "static/media/5_r_molbert.750c293a.png";